export enum TabPathEnum {
  SHOP_INFO = 'food-management/shop-information',
  CATEGORY = 'food-categories',
  PRODUCT = 'foods/new',
  RESTAURANT_BUILDER = 'food-management/shop-builder',
}
